module.exports = __webpack_public_path__ + "media/assemble.69192b10.mp3";